import { ChangeDetectionStrategy, Component, EventEmitter, InjectionToken, Input, Output, inject } from "@angular/core";
import { RouterService } from "../../../../../shared/_services/router.service";

export const APP_URL = new InjectionToken<string>("APP_URL");

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-left-menu",
    templateUrl: "./left-menu.component.html",
    styleUrl: "./left-menu.component.scss",
    standalone: false,
})
export class LeftMenuComponent {
    @Input() public isVisible: boolean = false;
    @Output() isVisibleChange = new EventEmitter<boolean>();

    onIsVisibleChange(value: boolean): void {
        this.isVisible = value;
        this.isVisibleChange.emit(value);
    }

    menuItems: { title: string; icon: string; url: string }[] = [
        { title: "Home", icon: "house", url: "/" },
        { title: "Alerts", icon: "bell", url: "/alerts" },
        { title: "Users", icon: "user", url: "/users" },
        { title: "Trading sessions", icon: "clock-rotate-left", url: "/trading-sessions" },
        { title: "Trading symbols", icon: "socks", url: "/trading-symbols" },
        { title: "Trading symbols lists", icon: "list", url: "/trading-symbols-lists" },
        { title: "Pricing packages", icon: "money-bills", url: "/pricing-packages" },
        { title: "Marketplace", icon: "store", url: "/marketplace" },
        { title: "Logs", icon: "file-lines", url: "/logs" },
    ];

    private readonly routerService = inject(RouterService);
    private readonly appUrl = inject(APP_URL);

    navigate(url: string): void {
        setTimeout(() => this.routerService.navigate(url));
        this.isVisible = false;
        this.isVisibleChange.emit(false);
    }

    signOut(): void {
        localStorage.removeItem("token");
        window.location.href = this.appUrl;
    }
}
